/* istanbul ignore file */

import { Carriers } from '../constants/carriers';
import protectiveUri from './assets/protective.png';
import { CarrierConfig } from './carrierConfig';

export class CarrierProtective extends CarrierConfig {
  getCarrier(): Carriers {
    return Carriers.PROTECTIVE;
  }
  getCarrierDisplayName(): string {
    return 'Protective Life Insurance Company';
  }
  getLabel(): string {
    return 'Protective';
  }
  supportLetterGeneration(): boolean {
    return true;
  }
  getCarrierLogo(): string {
    return protectiveUri;
  }
}
